<template>
  <div class="ladging">
    <section
      id="topbar"
      class="d-flex align-items-center"
      v-if="$store.state.app.activeGroup.id != 9254"
    >
      <div
        class="container d-flex justify-content-center justify-content-md-between"
      >
        <div class="contact-info d-flex align-items-center"></div>
        <div
          v-if="$store.state.app.activeGroup.id == 9247"
          class="align-items-center contact-links"
        >
          <a href="#" class="text-white mg-r-20">
            <feather class="mg-r-5" type="globe" :size="16"></feather>Байршил
            <b>ХУД 11-р хороо, Зайсан УМЭАЦТЛ</b>
          </a>
          <a href="#" class="text-white">
            <feather class="mg-r-5" type="phone" :size="16"></feather>Холбоо
            барих <b>70110469</b>
          </a>
        </div>
        <div v-else class="align-items-center contact-links">
          <a href="#" v-if="locationHref == '#'" class="text-white mg-r-20">
            <feather class="mg-r-5" type="globe" :size="16"></feather>Байршил
          </a>
          <router-link
            v-else
            :to="{
              name: $store.state.app.activeGroup.publicPage.route,
              params: { id: locationHref, cid: 0 }
            }"
            class="text-white mg-r-20"
          >
            <feather class="mg-r-5" type="globe" :size="16"></feather>Байршил
          </router-link>
          <a href="#" v-if="contactHref == '#'" class="text-white">
            <feather class="mg-r-5" type="phone" :size="16"></feather>Холбоо
            барих
          </a>
          <router-link
            v-else
            :to="{
              name: $store.state.app.activeGroup.publicPage.route,
              params: { id: contactHref, cid: 0 }
            }"
            class="text-white mg-r-20"
          >
            <feather class="mg-r-5" type="phone" :size="16"></feather>Холбоо
            барих
          </router-link>
        </div>
      </div>
    </section>
    <header-state v-if="$store.state.app.activeGroup.id == 9254" />
    <header-web v-else />
    <div v-if="comps.length == 0" style="min-height: calc(100vh - 408px)"></div>
    <template v-else>
      <loader-web
        :src="comp.st1"
        :comp="comp"
        v-for="(comp, i) in comps"
        :key="i"
        @on-show-task="showTask"
        @on-course-info="courseInfo"
      />
    </template>
    <footer-web />
    <b-modal
      v-model="modal.showCourse"
      hide-footer
      size="lg"
      centered
      :title="modal.title"
    >
      <div class="card mg-t-20">
        <div class="card-body text-left bd">
          <h6 class="bd-l bd-5 bd-gray-500 pd-l-5">Сургалтын агуулга:</h6>
          <p v-html="modal.course.taskDesc" class="course-inf-outer"></p>
        </div>
      </div>
      <div class="row">
        <div
          v-for="(c, ii) in modal.courseInfos"
          :key="ii"
          class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
        >
          <div class="card">
            <div class="card-body bd">
              <div class="media">
                <div class="mg-r-20">
                  <feather :type="c.icon"></feather>
                </div>
                <div class="media-body">
                  <h6
                    class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                  >
                    {{ c.title }}
                  </h6>
                  <h6 class="tx-13 tx-normal mg-b-0">{{ c.value }}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <router-link
          :to="{ name: 'login' }"
          class="btn btn-sm pd-x-15 btn-success btn-uppercase"
          >Хичээл сонгож үзэхийн тулд та нэвтэрнэ үү</router-link
        >
      </div>
    </b-modal>
    <b-modal
      v-model="modal.taskShow"
      hide-footer
      size="xl"
      centered
      :title="modal.title"
    >
      <div v-html="modal.task.taskDesc"></div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
var _ = require("lodash");
const moment = require("moment");

export default {
  components: {
    headerWeb: () => ({
      component: import("@/views/web/main/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    headerState: () => ({
      component: import("@/views/web/main/headerState.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    footerWeb: () => ({
      component: import("@/views/web/main/footer.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    loaderWeb: () => ({
      component: import("@/views/web/loader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      comps: [],
      comp: {},
      news: [],
      modal: {
        title: "",
        task: {},
        taskShow: false,
        showCourse: false,
        course: {},
        courseInfos: []
      },
      locationHref: "#",
      contactHref: "#"
    };
  },
  mounted() {
    if (this.$store.state.app.isMobile) {
      this.$router.push({ name: "login" });
    } else this.init(this.$route.params.id);
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init(pageId) {
      //this.toggleBodyClass('removeClass', 'navbar-nav-show');

      this.toggleBodyClass("addClass", "dynamic-locker");
      let _page = this.$store.state.app.pages.filter(x => x.id == pageId);
      //console.log(_page);
      if (_page.length > 0) {
        if (_page[0]["locTypeCode"] == "single_content") {
          this.loadSingleContent(_page[0]);
        } else if (_page[0]["locTypeCode"] == "list_content") {
          this.loadListContent(_page[0]);
        } else {
          this.loadComponents(pageId);
        }
        document.title = _page[0].task;
      }
      this.initHeaderTop();
    },
    initHeaderTop() {
      let _location = this.$store.state.app.pages.filter(
        x => x.st1 == "pageLocation"
      );
      if (_location.length) {
        this.locationHref = _location[0].id;
      }

      let _contact = this.$store.state.app.pages.filter(
        x => x.st1 == "pageContact"
      );
      if (_contact.length) {
        this.contactHref = _contact[0].id;
      }
    },
    loadListContent(page) {
      this.comps = [
        {
          st1: "dynamic/title",
          task: page.task
        },
        {
          st1: "dynamic/loc-type-list",
          locTypeId1: page.locTypeId1
        }
      ];
      this.toggleBodyClass("removeClass", "dynamic-locker");
    },
    loadSingleContent(page) {
      this.comps = [
        {
          st1: "dynamic/title",
          task: page.task
        },
        {
          st1: "dynamic/single-content",
          organizationTaskId: page.organizationTaskId
        }
      ];
      this.toggleBodyClass("removeClass", "dynamic-locker");
    },
    loadComponents(e) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "task/TaskInheritedDetail" },
        params: {
          id: e
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          let compBox = res.data.task.b.filter(x => x.ot == 355);
          if (compBox.length > 0) {
            this.loadBox(compBox[0].id);
          }
        }
      });
    },
    loadBox(boxId) {
      request({
        api: { method: "GET", url: "task/boxInTaskList" },
        params: {
          skip: 0,
          size: 10,
          id: boxId
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.comps = _.sortBy(res.data.tasks, "ord", "asc");
        }
      });
    },
    showTask(e) {
      this.modal.title = e.task;
      this.modal.task = e;
      this.modal.taskShow = true;
    },
    courseInfo(e) {
      this.modal.course = e;
      this.modal.title = e.task;
      this.modal.courseInfos = [];
      this.modal.courseInfos.push({
        id: 1,
        title: "Эхлэх огноо",
        value: moment(e.createdDate).format("YYYY.MM.DD"),
        icon: "calendar"
      });
      this.modal.courseInfos.push({
        id: 2,
        title: "Дуусах огноо",
        value: moment(e.dueDate).format("YYYY.MM.DD"),
        icon: "calendar"
      });
      this.modal.courseInfos.push({
        id: 2,
        title: "Сургалтын цаг:",
        value: 0 + " цаг",
        icon: "clock"
      });
      this.modal.courseInfos.push({
        id: 2,
        title: "Кредит оноо",
        value: e.i1,
        icon: "clock"
      });
      // this.modal.courseInfos.push({
      //   id: 2,
      //   title: "Шалгалттай эсэх ",
      //   value: "Тийм",
      //   icon: "pen-tool"
      // });
      this.modal.courseInfos.push({
        id: 2,
        title: "Сертификаттай эсэх",
        value: e.i6 == 1 ? "Тийм" : "Үгүй",
        icon: "award"
      });

      this.modal.showCourse = true;
      //console.log(e);
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.id != oldRoute.params.id) {
        Object.assign(this.$data, this.$options.data());
        this.$nextTick(() => {
          this.init(newRoute.params.id);
        });
      }
    }
  }
};
</script>

<style lang="scss">
// .is-golomt{
.ladging {
  background: white;
  #topbar {
    background: #0073b1;
    height: 40px;
    font-size: 14px;
    transition: all 0.5s;
    color: #fff;
    padding: 0;

    .contact-links {
      a {
        i {
          // display: inline-block !important;
          margin-bottom: -5px;
        }
      }
    }
  }
  .card.top-courses {
    border: none;
    // box-shadow: 0 8px 6px -6px black;
    box-shadow: 0 24px 32px -16px rgb(0 97 179 / 16%);
    .card-footer {
      border-radius: 0 0 10px 10px;
    }
  }
  #header {
    background: #fff;
    transition: all 0.5s;
    z-index: 997;
    height: 72px;
    .logo {
      font-size: 16px;
      margin: 0;
      padding: 0;
      line-height: 2.4;
      font-weight: 600;
      color: #444;
    }

    .nav {
      .nav-item {
        .nav-link {
          font-size: 14px;
          font-weight: 400;
          color: #616e82;
        }
      }
    }
  }
  .section-title {
    text-align: center;
  }
  .golomt-footer {
    background-color: #121315;
    background-image: url("/assets/img/golomt/bg-footer.png");
    background-repeat: no-repeat;
    .copyright {
      border-top: 2px solid #202123;
      background-color: #121315;
      span {
        color: #6d6d6d;
      }
    }
  }
}
.course-inf-outer {
  p {
    img {
      max-width: 100% !important;
    }
  }
  img {
    max-width: 100% !important;
  }
}
// }
</style>
